export type CountryCode =
  | "CL"
  | "AR"
  | "PE"
  | "BO"
  | "CO"
  | "MX"
  | "US"
  | "ES"
  | "VE"
  | "BR"
  | "UY"
  | "PY"
  | "EC";

export type Country = {
  code: CountryCode;
  name: string;
  dialCode: string;
  maxLength: number;
  placeholder: string;
};

export const COUNTRIES: Country[] = [
  {
    code: "CL",
    name: "Chile",
    dialCode: "+56",
    maxLength: 9,
    placeholder: "912345678",
  },
  {
    code: "AR",
    name: "Argentina",
    dialCode: "+54",
    maxLength: 10,
    placeholder: "1123456789",
  },
  {
    code: "PE",
    name: "Perú",
    dialCode: "+51",
    maxLength: 9,
    placeholder: "912345678",
  },
  {
    code: "BO",
    name: "Bolivia",
    dialCode: "+591",
    maxLength: 8,
    placeholder: "71234567",
  },
  {
    code: "CO",
    name: "Colombia",
    dialCode: "+57",
    maxLength: 10,
    placeholder: "3001234567",
  },
  {
    code: "MX",
    name: "México",
    dialCode: "+52",
    maxLength: 10,
    placeholder: "5512345678",
  },
  {
    code: "US",
    name: "United States",
    dialCode: "+1",
    maxLength: 10,
    placeholder: "2125550123",
  },
  {
    code: "ES",
    name: "España",
    dialCode: "+34",
    maxLength: 9,
    placeholder: "612345678",
  },
  {
    code: "VE",
    name: "Venezuela",
    dialCode: "+58",
    maxLength: 10,
    placeholder: "4121234567",
  },
  {
    code: "BR",
    name: "Brasil",
    dialCode: "+55",
    maxLength: 11,
    placeholder: "11912345678",
  },
  {
    code: "UY",
    name: "Uruguay",
    dialCode: "+598",
    maxLength: 8,
    placeholder: "91234567",
  },
  {
    code: "PY",
    name: "Paraguay",
    dialCode: "+595",
    maxLength: 9,
    placeholder: "981234567",
  },
  {
    code: "EC",
    name: "Ecuador",
    dialCode: "+593",
    maxLength: 9,
    placeholder: "991234567",
  },
];

export const DEFAULT_COUNTRY_CODE: CountryCode = "CL";

export const getDefaultCountry = (): Country =>
  COUNTRIES.find((c) => c.code === DEFAULT_COUNTRY_CODE)!;

export const getCountryByCode = (code: CountryCode): Country =>
  COUNTRIES.find((c) => c.code === code) ?? getDefaultCountry();

export function buildE164(dialCode: string, digits: string): string {
  if (!digits) return "";
  return `${dialCode}${digits}`;
}

export function parseE164(value: string | null | undefined): {
  country: Country;
  digits: string;
} {
  const fallback = getDefaultCountry();
  if (!value) return { country: fallback, digits: "" };

  if (value.startsWith("+")) {
    const sorted = [...COUNTRIES].sort(
      (a, b) => b.dialCode.length - a.dialCode.length,
    );
    const match = sorted.find((c) => value.startsWith(c.dialCode));
    if (match) {
      const rawDigits = value.slice(match.dialCode.length).replace(/\D/g, "");
      return { country: match, digits: rawDigits.slice(0, match.maxLength) };
    }
  }

  const digits = value.replace(/\D/g, "").slice(0, fallback.maxLength);
  return { country: fallback, digits };
}
